import React from 'react';
import { node, func } from 'prop-types';
import Warning from 'react-material-icons/icons/alert/warning';
import './index.css';

const SnackBar = ({ children, icon: IconComponent, ...props }) =>
  children ? (
    <div className="SnackBar" {...props}>
      <IconComponent className="SnackBar__icon" /> {children}
    </div>
  ) : null;

SnackBar.propTypes = {
  children: node,
  icon: func,
};
SnackBar.defaultProps = {
  children: null,
  icon: Warning,
};

export default SnackBar;



// WEBPACK FOOTER //
// ../ui-components/components/SnackBar/index.jsx